import { InitialReservationInquiryAmount } from '.';
import { Actions, types } from './actions';

const initialState: InitialReservationInquiryAmount = {
  unregisteredAmount: 0,
};

const reducer = (state = initialState, action: Actions): InitialReservationInquiryAmount => {
  switch (action.type) {
    case types.RESERVATION_INQUIRY_AMOUNT_SIDEBAR:
      return action.payload;

    default:
      return state;
  }
};

export default reducer;
